/**
 * @license Angular v19.2.6
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */

import { $localize } from './localize-CajB9YLv.mjs';

// Attach $localize to the global context, as a side-effect of this module.
globalThis.$localize = $localize;
export { $localize };
